import {
  getDefaultWishlist as publicGetDefaultWishlist,
  addItem as publicAddItem,
  removeItem as publicRemoveItem,
  bulkUpdateWishlistTags as publicBulkUpdateWishlistTags,
  bulkUpdateWishlistTagsByFilter as publicBulkUpdateWishlistTagsByFilter,
} from './ecom-v1-wishlist-wishlists.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

/** @internal */
export const getDefaultWishlist: MaybeContext<
  BuildRESTFunction<typeof publicGetDefaultWishlist> &
    typeof publicGetDefaultWishlist
> = /*#__PURE__*/ createRESTModule(publicGetDefaultWishlist);
/** @internal */
export const addItem: MaybeContext<
  BuildRESTFunction<typeof publicAddItem> & typeof publicAddItem
> = /*#__PURE__*/ createRESTModule(publicAddItem);
/** @internal */
export const removeItem: MaybeContext<
  BuildRESTFunction<typeof publicRemoveItem> & typeof publicRemoveItem
> = /*#__PURE__*/ createRESTModule(publicRemoveItem);
/** @internal */
export const bulkUpdateWishlistTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateWishlistTags> &
    typeof publicBulkUpdateWishlistTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateWishlistTags);
/** @internal */
export const bulkUpdateWishlistTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateWishlistTagsByFilter> &
    typeof publicBulkUpdateWishlistTagsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateWishlistTagsByFilter);

export { WebhookIdentityType } from './ecom-v1-wishlist-wishlists.universal.js';
export {
  Wishlist,
  WishlistItem,
  CatalogReference,
  ExtendedFields,
  Tags,
  TagList,
  WishlistItemAdded,
  WishlistItemRemoved,
  WishlistTagsModified,
  GetDefaultWishlistRequest,
  GetDefaultWishlistResponse,
  AddItemRequest,
  AddItemResponse,
  RemoveItemRequest,
  RemoveItemResponse,
  BulkUpdateWishlistTagsRequest,
  BulkUpdateWishlistTagsResponse,
  ItemMetadata,
  ApplicationError,
  BulkUpdateWishlistTagsResult,
  BulkActionMetadata,
  BulkUpdateWishlistTagsByFilterRequest,
  BulkUpdateWishlistTagsByFilterResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  AddItemOptions,
  RemoveItemOptions,
  BulkUpdateWishlistTagsOptions,
  BulkUpdateWishlistTagsByFilterOptions,
} from './ecom-v1-wishlist-wishlists.universal.js';
export {
  WebhookIdentityTypeWithLiterals,
  AddItemApplicationErrors,
  BulkUpdateWishlistTagsApplicationErrors,
  BulkUpdateWishlistTagsByFilterApplicationErrors,
} from './ecom-v1-wishlist-wishlists.universal.js';
